<div class="heading-container">
  <h1>Registrering steg 3/3</h1>
</div>
<app-agreement (onSigned)="signed($event)"></app-agreement>